export default __webpack_public_path__ + "static/media/mw310x310.e14add8d.png";